import { CSSObject } from '@mantine/core'
import { MantineThemeComponents } from '@mantine/styles/lib/theme/types/MantineTheme'
import { getCheckboxStyles } from 'plugin-mantine-resources/src/helpers/checkboxHelpers'

export const Checkbox: MantineThemeComponents['Checkbox'] = {
    styles: (__, _, runtimeProps): Record<string, CSSObject> => {
        return getCheckboxStyles(runtimeProps)
    }
}
